import { createFileRoute } from "@tanstack/react-router";
import { getImportLayoutData } from "#/modules/school.import/import.functions";

export const Route = createFileRoute(
  "/$locale/{-$schoolyear}/_authenticated/$school/detail/import/$type",
)({
  loader: ({ params }) =>
    getImportLayoutData({ data: { school: params.school, type: params.type } }),
});
